module.exports = __webpack_public_path__ + "img/RimouskiSb-Regular.7cc0a280.svg";